interface Props {
  rating: number;
}

export function RatingStars({ rating }: Props) {
  const clamped = Math.min(Math.max(rating, 0), 5);
  const percent = (clamped / 5) * 100;
  return (
    <div
      className="relative inline-block select-none text-base leading-none tracking-tight"
      aria-label={`${clamped.toFixed(1)} out of 5`}
    >
      <span className="text-slate-700">★★★★★</span>
      <span
        className="absolute inset-0 overflow-hidden text-amber-400"
        style={{ width: `${percent}%` }}
      >
        ★★★★★
      </span>
    </div>
  );
}
